import React, { FunctionComponent } from 'react'
import { Route, Switch, RouteComponentProps } from 'react-router-dom'

import { WebsitesContainer } from '../../../containers/old'
import { Err404 } from '../../../components'

import RestrictedRoute from '../../util/RestrictedRoute'

interface WebsiteRouterProps extends RouteComponentProps {}

const WebsiteRouter: FunctionComponent<WebsiteRouterProps> = ({ match }) => (
  <Switch>
    <RestrictedRoute
      path={`${match.path}/add`}
      minimumRequiredRole="manager"
      render={() => <WebsitesContainer basePath={match.url} showAddForm />}
    />
    <Route
      path={match.path}
      render={props => <WebsitesContainer basePath={props.match.url} />}
    />
    <Route component={Err404} />
  </Switch>
)

export default WebsiteRouter
